













































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetDianxingshetu$ } from "@/request/shezhenjiaoxue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import PhotoPreview from "@/components/pic-preview.vue";
import catalogData from "./catalog";
@Component({
  components: {
    MainHeader,
    LeftNav,
    PhotoPreview,
  },
})
export default class SzjxDxst extends Vue {
  private catalogData: any[] = catalogData;
  private result: any = {};
  private ifShowPhotoPreview: boolean = false;
  private tempUrl: any = "";
  /**
   * @description 展示第二层
   */
  private showSecond(index, ifShow) {
    this.catalogData[index]["ifShowSecond"] = ifShow;
  }
  /**
   * @description 展示第三层
   */
  private showThird(index, fIndex, ifShow) {
    this.catalogData[fIndex]["children"][index]["ifShowThird"] = ifShow;
  }
  /**
   * @description 获取内容
   */
  private fetchContent(title1, title2?, title3?) {
    const parmas: any = {
      title1,
      title2,
      title3,
    };
    GetDianxingshetu$(this, parmas).then((data: any) => {
      console.log(data);
      this.result = data;
    });
  }
  /**
   * @description 预览图片
   */
  private showPhotoPreview(url) {
    this.tempUrl = url;
    this.ifShowPhotoPreview = true;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchContent("望舌质", "舌神", "荣舌");
  }
}
